import { DataValidationIssueType } from '@app/analyze-data/enums/data-validation-filter-options.enum';

export const DATA_VALIDATION_ISSUE_TYPE_LABELS: Record<DataValidationIssueType, string> = {
    [DataValidationIssueType.MISSING]: 'Missing',
    [DataValidationIssueType.INVALID]: 'Invalid',
    [DataValidationIssueType.MISFORMATTED]: 'Misformatted',
    [DataValidationIssueType.TOO_LONG]: 'Too long',
    [DataValidationIssueType.TOO_SHORT]: 'Too short',
    [DataValidationIssueType.AI_REJECTION]: 'Not fixed with AI'
};

/**
 * The issue types the taxonomy rules produce, in Issue type filter order. AI rejections are not one
 * of them: the backend only reports them when a request asks for them by name.
 */
export const TAXONOMY_ISSUE_TYPES: DataValidationIssueType[] = [
    DataValidationIssueType.INVALID,
    DataValidationIssueType.MISFORMATTED,
    DataValidationIssueType.MISSING,
    DataValidationIssueType.TOO_LONG,
    DataValidationIssueType.TOO_SHORT
];

/** Every issue type the Data Validation tab shows, in Issue type filter order. */
export const DATA_VALIDATION_ISSUE_TYPES: DataValidationIssueType[] = [
    ...TAXONOMY_ISSUE_TYPES,
    DataValidationIssueType.AI_REJECTION
];
